<template>
  <div>
    <PageAllow controller="Payment" action="getPaySettings" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{ $t("Payment.chinaPay.title") }}

          <v-spacer></v-spacer>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <ValidationObserver ref="observer">
            <v-container>
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Payment.chinaPay.application") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  {{ $t("Payment.chinaPay.application_title") }}
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.chinaPay.chinapay_mer_id") + $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.chinaPay.chinapay_mer_id')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="settings.chinapay_mer_id"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'chinapay_mer_id')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- zhengshu -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Payment.chinaPay.file") + $t("Global.colon") }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.chinaPay.file')"
                    rules="required"
                  >
                    <v-file-input
                      v-model="File"
                      show-size
                      :label="$t('Payment.chinaPay.import')"
                      accept=".pfx"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'file')
                          .concat(errors)
                      "
                    ></v-file-input>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.chinaPay.chinapay_sign_check") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-text-field
                    v-model="settings.chinapay_sign_check"
                    single-line
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <!-- 启用 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.chinaPay.chinapay_h5_enable") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="settings.chinapay_h5_enable">
                    <v-radio :label="$t('Payment.off')" key="0" value="0" />
                    <v-radio :label="$t('Payment.on')" key="1" value="1" />
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-container>
          </ValidationObserver>
        </v-card-text>
      </v-card>
      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <!-- 保存 -->
              <v-btn color="success" block @click="save()">
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("Payment.save") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>
  </div>
</template>

<script>
import Payment from "@/api/payment";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import { mapState } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
// import Required from "@/components/plugins/Required";

export default {
  data: () => ({
    settings: {},
    serverErrors: [],
    File: null,
  }),
  components: {
    PageAllow,
    Breadcrumbs,
    // Required,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.fundManagement"),
        disabled: false,
        href: "/receipts",
      },
      {
        text: i18n.t("Nav.payment"),
        disabled: true,
        href: "/payment",
      },
    ],
    ...mapState(["loading"]),
  },

  mounted() {
    this.getAlipayFromAPI();
  },

  watch: {
    File: {
      handler() {},
    },
  },
  methods: {
    getAlipayFromAPI() {
      Payment.fetch({
        keys: ["chinapay_mer_id", "chinapay_sign_check", "chinapay_h5_enable"],
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.settings = response.data.settings;
            if (
              this.settings.chinapay_h5_enable == null ||
              typeof this.settings.chinapay_h5_enable == "undefined" ||
              this.settings.chinapay_h5_enable == undefined
            ) {
              this.settings.chinapay_h5_enable = "0";
            }
          }
        }.bind(this)
      );
    },

    save() {
      if (this.File && this.settings.chinapay_mer_id) {
        Payment.chinaFileUpload(this.File, this.settings.chinapay_sign_check);

        Payment.chinaPaySave(this.settings).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$router.push("/payment");
            }
          }.bind(this)
        );
      }
    },
  },
};
</script>

<style>
</style>